import { render, staticRenderFns } from "./reindeer.vue?vue&type=template&id=36b84c93&"
import script from "./reindeer.vue?vue&type=script&lang=js&"
export * from "./reindeer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports